// src/pages/ShasanNirnay.jsx
import React from "react";

const shasanDecisions = [
  {
    title: "मा. बाळासाहेब ठाकरे स्मृती मातोश्री ग्रामपंचायत बांधणी योजनेंतर्गत सातारा जिल्ह्यातील 4 ग्रामपंचायतींच्या इमारत बांधकामास मंजुरी प्रदान करणेबाबत…",
    date: "18/09/2025",
    pdf: "#",
    size: "178 KB",
  },
  {
    title: "कोकण ग्रामीण पर्यटन विकास कार्यक्रमांतर्गत कर्दे ता.दापोली जि. रत्नागिरी येथील प्रशासकीय मान्यता दिलेल्या कामांना निधी वितरीत करण्याबाबत.",
    date: "18/09/2025",
    pdf: "#",
    size: "136 KB",
  },
  {
    title: "सन 2025-26 राज्य शासनाकडून समुदाय संसाधन व्यक्तीं (Community Resource Person-CRP) / प्रेरिका (ICRP) / सखी यांना देण्यात येणारे वाढीव मानधन निधी वितरीत करणेबाबत.",
    date: "17/09/2025",
    pdf: "#",
    size: "168 KB",
  },
  {
    title: "महाराष्ट्र विकास सेवा, गट-ब मधील सहायक गट विकास अधिकारी (एस-16) संवर्गातील अधिकाऱ्यांना गट विकास अधिकारी, गट-अ (एस-20) संवर्गात तदर्थ पदोन्नती देणेबाबत. (निवडसूची वर्ष 2024-25)",
    date: "15/09/2025",
    pdf: "#",
    size: "350 KB",
  },
  // इथे बाकी data सुद्धा असू शकतो
];

const ShasanNirnay = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-800 mb-8 text-center">
        शासन निर्णय
      </h1>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
          <thead className="bg-gray-100">
            <tr>
              <th className="py-3 px-6 text-left text-gray-700 font-semibold">
                शीर्षक
              </th>
              <th className="py-3 px-6 text-left text-gray-700 font-semibold">
                तारीख
              </th>
              <th className="py-3 px-6 text-left text-gray-700 font-semibold">
                पहा / डाउनलोड करा
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {shasanDecisions.map((item, index) => (
              <tr key={index}>
                <td className="py-3 px-6 text-gray-700">{item.title}</td>
                <td className="py-3 px-6 text-gray-700">{item.date}</td>
                <td className="py-3 px-6 text-blue-600">
                  <a
                    href={item.pdf}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline"
                  >
                    पहा ({item.size})
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ShasanNirnay;
